/* eslint @angular-eslint/directive-selector: 0 */ // --> OFF
/* eslint @typescript-eslint/naming-convention: 0 */ // --> OFF

import {
  Directive,
  Input,
  NgModule,
  TemplateRef,
  ViewContainerRef,
} from '@angular/core';

interface ILetContext<T> {
  ngLet: T;
}

@Directive({
  selector: '[ngLet]',
})
export class LetDirective<T> {
  private _context: ILetContext<T> = { ngLet: undefined };

  constructor(
    viewContainer: ViewContainerRef,
    templateRef: TemplateRef<ILetContext<T>>,
  ) {
    viewContainer.createEmbeddedView(templateRef, this._context);
  }

  @Input()
  private set ngLet(value: T) {
    this._context.ngLet = value;
  }
}

@NgModule({
  declarations: [LetDirective],
  exports: [LetDirective],
})
export class LetModule {}
